/* Uploadcare image display component */

import {CSSProperties, MouseEventHandler} from 'react';
import {getImageUrl, Transformations} from '../../../utils/uploadcare_utils';

type Props = {
  uuid: string;
  transformations?: Transformations;
  title?: string;
  onClick?: MouseEventHandler<HTMLImageElement>;
  alt?: string;
  style?: CSSProperties;
  className?: string;
};

const UploadcareImage = ({
  uuid,
  transformations,
  alt,
  title,
  onClick,
  style,
  className,
}: Props): JSX.Element => {
  const src = getImageUrl(uuid, transformations);

  return (
    <img
      width="100%"
      src={src}
      alt={alt}
      title={title}
      onClick={onClick}
      style={style}
      className={className}
    />
  );
};

export default UploadcareImage;
